<ejs-dialog
	#modal
	(close)="closeModal()"
	cssClass="modal-md"
	[attr.data-test-id]="'askRevAssureModal'">
	<ng-template #header>
		<div class="dlg-template">Ask RevAssure</div>
	</ng-template>
	<ng-template #content>
		<form [formGroup]="formGroup" #templateForm="ngForm" (ngSubmit)="submit()">
			<div class="alert alert-info">
				Ask our team of experts about any medical record documentation or coding questions you have and they will provide assistance.
			</div>
			@if (formGroup.invalid && templateForm.submitted) {
				<gandalf-lib-validation-messages
					[form]="formGroup"
					[requestObj]="request">
				</gandalf-lib-validation-messages>
			}
			<div class="row mb-3" [attr.data-test-id]="'questionFormGroup'">
				<label class="required">Question</label>
				<textarea formControlName="question" class="e-input" rows="10"></textarea>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'emailAddressFormGroup'">
				<label class="required">Your Email Address</label>
				<input formControlName="emailAddress" class="e-input"/>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<maj-button icon="times" label="Cancel" (clicked)="closeModal()" dataTestId="askRevAssureCancelButton"></maj-button>
		<maj-button type="submit" variant="primary" label="Submit" (clicked)="submitForm($event)"
					dataTestId="askRevAssureSubmitButton"></maj-button>
	</ng-template>
</ejs-dialog>
